import { type ApiError } from '@webapp/core/interfaces/api/ApiError'
import { type OrderDraftItemFieldErrors } from '@webapp/modules/purchasing/business-logic/types/OrderDraftItemFieldErrors'
import { mapOrderItemApiFieldError } from './mapOrderItemApiFieldError'

/** Keeps only the errors the item form and card show (see `mapOrderItemApiFieldError`). */
export const mapOrderDraftItemFieldErrors = (
  errors: ApiError['errors'] | undefined
): OrderDraftItemFieldErrors =>
  Object.entries(errors ?? {}).reduce<OrderDraftItemFieldErrors>(
    (result, [apiField, { code, message }]) => {
      const field = mapOrderItemApiFieldError(apiField, code)
      if (field) result[field] = { code, message }
      return result
    },
    {}
  )
